module.exports = __webpack_public_path__ + "img/Metastasis-PRCA_10X_AIC.dc83c2ab.png";